
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IsString } from 'class-validator';

@Injectable({
	providedIn: 'root'
})
export class StakeholderReferenceService {
	url = environment.apiUrl;
	constructor(private http: HttpClient) {}

	getStakeholderReference(type: string): Observable<any[]> {

        // const httpOptions = {
        //     headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        //     type: type
        // };
      
        // let params = new HttpParams();
        // params = params.append('type', type);

        // console.log("Http Options ", httpOptions);
         
		return this.http.get<any[]>(this.url + 'genericreference?type=' + type);
  }
  
  getStakeholderReferenceGroup(type: string): Observable<any[]> {

    // const httpOptions = {
    //     headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    //     type: type
    // };
  
    // let params = new HttpParams();
    // params = params.append('type', type);

    // console.log("Http Options ", httpOptions);
     
return this.http.get<any[]>(this.url + 'genericreference?type=' + type);
}

	createStakeholderReference(data: any[], type: string): Observable<any[]> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
            };
      
          let params = new HttpParams();
          params = params.append('type', type);
		return this.http.post<any[]>(this.url + 'genericreference/createReference?type='+ type, data);
	}
	getSingleStakeholderReference(id: string, type: string): Observable<any> {

        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
            };
      
          let params = new HttpParams();
          params = params.append('type', type);
		return this.http.get(this.url + 'genericreference/' + id,httpOptions);
	}

	updateStakeholderReference(data: any[], type: string): Observable<any[]> {
 console.log("Reaching Update function ", type);
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
            };
      
          let params = new HttpParams();
          params = params.append('type', type);

		return this.http.post<any[]>(this.url + 'genericreference/update?type='+ type, data);
	}

	deleteStakeholderReference(ids: any, type: string) {
    console.log("Reaching App Delete Service", ids );
    const httpOptions = {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
			body: ids
		};

		let params = new HttpParams();
    params = params.append('stakeholderRef', ids.join(', '));
    
   
		return this.http.delete(this.url + 'genericreference?type='+ type, httpOptions);
	}
}
